enum OccurrenceType {
  Once = "Once",
  Daily = "Daily",
  Weekly = "Weekly",
}

export default OccurrenceType;
